/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * For online locations: how the meeting room is sourced (defaults to toptoptime)
 */
export enum MeetingProvider {
  toptoptime = 'toptoptime',
  byo = 'byo',
  manual = 'manual'
}
